import { keepPreviousData } from "@tanstack/react-query";
import { TextFilterModeEnum } from "@exonn/js-sdk";

import { type ModuleTabsStore } from "src/framework/layout/ModuleTabsProvider.tsx";
import { useContentLocale } from "src/auth/hooks/useContentLocale.tsx";
import { useList } from "src/system/useList.tsx";

export const useEditTabsV2 = ({
  moduleTabsStore,
  resource,
  idParam,
  includes,
}: {
  moduleTabsStore: ModuleTabsStore;
  idParam: string;
  resource: string;
  includes?: string[];
}) => {
  const locale = useContentLocale() || "de";

  return useList({
    resource,
    page: {
      number: 1,
      size: 9_999, // should be safe number, I don't think user will have 10 000 open tabs
    },
    locale,
    filter: {
      items: [
        {
          field: "id",
          value: moduleTabsStore.editParams
            .map((params) => params[idParam])
            .join(","),
          operator: TextFilterModeEnum.Exact,
        },
      ],
    },
    include: includes,

    queryOptions: {
      enabled: !!moduleTabsStore.editPaths.length,
      placeholderData: keepPreviousData,
    },
  });
};
